<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.HEADER_DETAIL')
        }}
      </caption>
      <thead>
        <tr>
          <th>
            {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.STARTED_AT') }}
          </th>
          <th>
            {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.ENDED_AT') }}
          </th>
          <th>
            {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.CONTACT_NAME') }}
          </th>
          <th>
            {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.PHONE_NUMBER') }}
          </th>
          <th>
            {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.INTERACTIONS') }}
          </th>
          <th>
            {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.DURATION') }}
          </th>
          <th>{{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.INBOX') }}</th>
          <th>
            {{
              $t(
                'VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.TABLE.CONVERSATION_LINK'
              )
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(msg, index) in paginatedData"
          :key="index"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ formatDate(msg.started_at) }}</td>
          <td>{{ formatDate(msg.ended_at) }}</td>
          <td>{{ msg.contact_name || '-' }}</td>
          <td>{{ msg.phone_number || '-' }}</td>
          <td>{{ msg.interactions_count || 0 }}</td>
          <td>{{ formatDuration(msg.duration_interaction) }}</td>
          <td>{{ msg.inbox_name || '-' }}</td>
          <td>
            <a
              :href="msg.link_conversation"
              target="_blank"
              rel="noopener"
              :title="msg.link_conversation"
            >
              {{ truncateLink(msg.link_conversation) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.PAGINATION.PAGE') }}
        {{ currentPage }}
        {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.COMMON.OF') }}
        {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('VIRTUAL_ASSISTANT_CONSUMPTIONS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VirtualAssistantEventsDetailsTable',
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.events.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.events.length / this.perPage);
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short',
      });
    },
    formatDuration(seconds) {
      if (!seconds) return '00:00:00';

      const totalSeconds = Math.floor(seconds);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;

      return [hours, minutes, secs]
        .map(v => String(v).padStart(2, '0'))
        .join(':');
    },
    truncateLink(link, maxLength = 30) {
      if (!link) return '';
      if (link.length <= maxLength) return link;
      return link.slice(0, maxLength) + '...';
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
